import React from 'react';
import styled from 'styled-components';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { colors } from '../../../../../constants/colors';
import { Actions, Events } from '../../../util/analytics';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import history from '../../../../../core/history';
import GenericRow from './GenericRow';

const GreyRight = styled(ChevronRight).withConfig({ componentId: 'sc-13haq3u-0' })`
  color: ${colors.lightText};
`;

interface Props {
  bookingId?: string;
  invoiceId: string;
  userProfileId?: string;
}

const PayBill = ({ bookingId, invoiceId, userProfileId }: Props) => {
  const handleClick = (event: any) => {
    event.preventDefault();
    const action = Actions.CLICK_PAY_BILL;
    analyticsTrackEvent(Events.PAST_CARD, {
      action,
      bookingId,
      userProfileId,
    });
    history.push(`/account/payments/${invoiceId}`);
  };

  return (
    <GenericRow onClick={handleClick}>
      Pay your bill
      <GreyRight />
    </GenericRow>
  );
};

export default PayBill;
